<template>
	<div class="FundRecharge" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-moneynt Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 资金发票 / 专属账号</span>
		</div>
		<div>
			<div class="no-ws content_Box m-t-15" v-if="is_NoshowWS" :style="{'min-height': windowSizeHeight-120 +'px'}">
				<span>企业未开通银行支付通道</span>
			</div>
			<div class="oneContent" v-if="is_showWS">
				<el-row>
					<el-col :span="24">
						<div class="cardBox content_Box box-shadow m-t-15">
							<div class="right_title">
								<b>转账汇款说明</b>
							</div>
							<ol class="hint_text" type="1">
								<li>收款人是专属账号 <b class="text-color-red">"开户名称"</b> ，请仔细填写，否则无法打款成功也无法开出发票；</li>
								<li>汇款账号是贵司专属子账号，银行能根据账号进行来账识别，自动给汇款企业充值到平台，无需人工核账；</li>
								<li>汇款成功后，预计到账时间5-10分钟；</li>
								<li>每一笔成功支出有专属的银行电子回单，确保企业专款专用的资金更容易追溯；</li>
								<li>转账过程中有任何疑问，请拨打电话咨询客服：400-820-0088。</li>
							</ol>
						</div>
					</el-col>
				</el-row>
			</div>
			<!--  v-if="is_showWS" -->
			<div class="oneContent">
				<el-row>
					<el-col :span="24"  v-for="(item,index) in available_balance" :key="index" >
						<div class="cardBox content_Box box-shadow m-t-15">
							<div class="right_title">
								<b>专属账号信息 {{index+1}}</b>
							</div>
							<div class="bankContent">
								<div style="height:80px;">
									<img src="../assets/img/logo-wangshang.png" alt="" height="50px">
								</div>
								<div class="clear">
									<div class="fl w-300">
										<span>开户名称：</span>
										<span style="color: #D0121B; ">{{item.name}}</span>
									</div>
									<div class="fl">
										<span>签约日期：</span>
										<span >{{item.sign_date_start}}</span>
									</div>
								</div>
								<div class="clear"> 
									<div class="fl w-300">
										<span>开户银行：</span>
										{{item.channel_name}}
									</div>
									<div class="fl">
										<span>终止日期：</span>
										<span >{{item.sign_date_end}}</span>
									</div>
								</div>
								<div class="clear"> 
									<div class="fl w-300">
										<span>银行卡号：</span>
										<span class="font-Tahoma " style="color: #2C4198;">{{item.bank_account | sub_blank}}</span>
									</div>
									<div class="fl"> 
										<div class="fl contract_rate_title">签约费率：</div>
										<div class="fl">  
											<div class="rate-line-height" v-for="(rate,index) in item.contract_rate" :key="index" >
												<span class="font-Tahoma " >{{ rate.start }} <a>元</a> &lt; </span>
												<span class="font-Tahoma  p-l-40 p-r-40" >—</span>  
												<span class="font-Tahoma" >&lt;= {{ rate.end  }} 
													<a v-if="index != item.contract_rate.length-1">元</a>  
												</span> 
												<span class="font-Tahoma p-l-40 p-r-40">,</span>   
												<span class="font-Tahoma">{{ rate.rate }} %</span>
												<br/>
											</div>
										</div>
										<div class="clear"></div>
									</div>
								</div>
								<div class="clear">
									<span>【 {{userInfo.enterprise_name}} 专属 】</span>
								</div>
							</div>

						</div>
					</el-col>
					
				</el-row>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'FundRecharge',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
				available_balance: [], //账户余额
				is_showWS:false, //网商显示发放通道
				is_NoshowWS:false, //没有发放通道
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				this.getBalance();
			},
			getBalance(){ //获取账户余额
				this.$http.post(this.url + '/zhongfy/company/getPayChannelList').then((res) => {
					let data = res.data; 
					if (data.code == '200') {
						let available_balance = data.data;   
						for(let i = 0 ;i< available_balance.length ; i++){ 
							available_balance[i].contract_rate = JSON.parse(available_balance[i].contract_rate); 
							let contract_rate = available_balance[i].contract_rate;
							for(let n = 0 ; n < contract_rate.length ; n++){
								contract_rate[n].rate = (contract_rate[n].rate*100).toFixed(2);
							}
						} 
						this.available_balance = available_balance;
						this.is_showWS = true; 
						console.log(this.available_balance)
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (err) => {
					return;
				});
			},
			 
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	/* .FundRecharge {
		margin: 15px 15px 0 15px;
	} */

	.no-ws{
		text-align: center;
		font-size: 22px;
	}
	
	.oneContent {
		/* margin-top: 15px; */
	}

	.cardBox {
		min-height: 200px;
		padding: 15px;
		background-color: #FFFFFF;
	}

	.right_title {
		height: 30px;
		font-size: 14px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		color: var(--theme-orange);
	}

	.hint_text{
		padding: 30px;
	}
	
	.hint_text li {
		line-height: 34px;
		font-size: 14px;
		color: #666666;
		list-style-type: decimal;
	}

	.financialDetails_title {
		height: 30px;
		font-size: 14px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		color: var(--theme-black);
		margin-bottom: 15px;
	}

	.bankContent {
		padding: 30px;
	}

	.bankContent>div {
		color: #444444;
		font-size: 14px;
		height: 30px;
	}

	.bankContent span, .contract_rate_title {
		color: #999999;
		font-size: 13px; 
	}
	
	.rate-line-height{
		height: 30px; 
	}
	
	.w-300{width: 400px;}
</style>



// WEBPACK FOOTER //
// src/components/FundRecharge.vue